import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { LanguageContext } from '../App';

interface TransferProps {
  left: any,
  right: any,
  handleToggleLeft: any,
  handleToggleRight: any,
  handleAllRight: any,
  handleCheckedRight: any,
  handleCheckedLeft: any,
  handleAllLeft: any,
  leftChecked: any,
  rightChecked: any,
  customList: any,
};

export default function TransferListCustom(props: TransferProps) {
  const { left, right, handleAllRight, handleCheckedRight, handleCheckedLeft, handleAllLeft, leftChecked, rightChecked, customList, handleToggleLeft, handleToggleRight } = props
  const { translations } = React.useContext(LanguageContext);
  
  return (
    <Grid
      container
      spacing={2}
      sx={{ justifyContent: "space-between", alignItems: 'center' }}
    >
      <Grid item xs>{customList(left, handleToggleLeft, leftChecked)}</Grid>
      <Grid item xs={2}>
        <Grid container direction="column" sx={{ alignItems: 'center' }}>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleAllRight}
            disabled={left.length === 0}
            aria-label="move all right"
          >
          { `${translations["lbl.react.desvincular.todas"]} >>` }
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
            >
            { `${translations["lbl.react.desvincular.selecionadas"]} >` }
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
            >
            { `< ${translations["lbl.react.vincular.selecionadas"]}` }
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleAllLeft}
            disabled={right.length === 0}
            aria-label="move all left"
            >
            { `<< ${translations["lbl.react.vincular.todas"]}` }
          </Button>
        </Grid>
      </Grid>
      <Grid item xs>{customList(right, handleToggleRight, rightChecked)}</Grid>
    </Grid>
  );
}
